// register.js — entry del bundle proc-v3 (F2.3c Fornitori + F2.3d
// Prodotti/Campagne + F2.3e Conversazioni/Ordini + F2.3f Tag/Magazzino +
// F2.3g Monitoraggio/Templates): viste del monolite in React, flag-gated.
// EAGER nel manifest, subito DOPO proc-v0-register: il modulo proc NON è un
// gruppo lazy (proc-v0.js è <script id=app-script> nel body e
// proc-v0-register è eager) — quindi eager col resto, come dash-v3.
// A flag spente (default OFF, UNA flag PER VISTA: shell_proc_v3_suppliers /
// shell_proc_v3_products / shell_proc_v3_campaigns /
// shell_proc_v3_conversations / shell_proc_v3_orders / shell_proc_v3_tags /
// shell_proc_v3_warehouse / shell_proc_v3_monitoring /
// shell_proc_v3_templates / shell_proc_v3_categories) il bundle è INERTE
// (ogni install* → false: il wrap
// della rispettiva window.render<Vista> non viene MAI installato, mondo v1
// runtime-identico).
// Tutta la logica di guardia vive in install.js (testata sotto node);
// qui SOLO il side-effect browser + l'aggancio delle factory React.
//
// Guardie __shellProcV3<Vista>Installed: se il file finisse iniettato due
// volte niente doppio wrap — si marcano SOLO a install riuscita (pattern
// sop-v3/register.js; ogni wrap ha comunque la sua guardia __procV3Wrapped).
import {
  installProcV3Suppliers, installProcV3Products, installProcV3Campaigns,
  installProcV3Conversations, installProcV3Orders,
  installProcV3Tags, installProcV3Warehouse,
  installProcV3Monitoring, installProcV3Templates,
  installProcV3Categories,
} from './install.js';
import { createProcV3Suppliers } from './SuppliersList.jsx';
import { createProcV3Products } from './ProductsList.jsx';
import { createProcV3Campaigns } from './CampaignsList.jsx';
import { createProcV3Conversations } from './ConversationsList.jsx';
import { createProcV3Orders } from './OrdersList.jsx';
import { createProcV3Tags } from './TagsList.jsx';
import { createProcV3Warehouse } from './WarehouseList.jsx';
import { createProcV3Monitoring } from './MonitoringList.jsx';
import { createProcV3Templates } from './TemplatesList.jsx';
import { createProcV3Categories } from './CategoriesView.jsx';

if (typeof window !== 'undefined') {
  if (!window.__shellProcV3SuppliersInstalled && installProcV3Suppliers(window, createProcV3Suppliers)) {
    window.__shellProcV3SuppliersInstalled = true;
  }
  if (!window.__shellProcV3ProductsInstalled && installProcV3Products(window, createProcV3Products)) {
    window.__shellProcV3ProductsInstalled = true;
  }
  if (!window.__shellProcV3CampaignsInstalled && installProcV3Campaigns(window, createProcV3Campaigns)) {
    window.__shellProcV3CampaignsInstalled = true;
  }
  if (!window.__shellProcV3ConversationsInstalled && installProcV3Conversations(window, createProcV3Conversations)) {
    window.__shellProcV3ConversationsInstalled = true;
  }
  if (!window.__shellProcV3OrdersInstalled && installProcV3Orders(window, createProcV3Orders)) {
    window.__shellProcV3OrdersInstalled = true;
  }
  if (!window.__shellProcV3TagsInstalled && installProcV3Tags(window, createProcV3Tags)) {
    window.__shellProcV3TagsInstalled = true;
  }
  if (!window.__shellProcV3WarehouseInstalled && installProcV3Warehouse(window, createProcV3Warehouse)) {
    window.__shellProcV3WarehouseInstalled = true;
  }
  if (!window.__shellProcV3MonitoringInstalled && installProcV3Monitoring(window, createProcV3Monitoring)) {
    window.__shellProcV3MonitoringInstalled = true;
  }
  if (!window.__shellProcV3TemplatesInstalled && installProcV3Templates(window, createProcV3Templates)) {
    window.__shellProcV3TemplatesInstalled = true;
  }
  if (!window.__shellProcV3CategoriesInstalled && installProcV3Categories(window, createProcV3Categories)) {
    window.__shellProcV3CategoriesInstalled = true;
  }
}
